import { useEffect, useState } from "react";
import {
  Button,
  Center,
  Code,
  Container,
  Group,
  Loader,
  Paper,
  SimpleGrid,
  Stack,
  Table,
  Text,
  Title,
} from "@mantine/core";
import { Link } from "wouter";
import { getPartnerMe } from "../api";
import { useStore } from "../store";
import Timeago from "../../../Boilerplate/_Shared/Timeago";

export default function PartnerHome() {
  const authToken = useStore((state) => state.authToken);
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getPartnerMe()
      .then((data) => {
        if (!cancelled) setMe(data);
      })
      .catch(() => {
        if (!cancelled) setMe(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [authToken]);

  if (loading) {
    return (
      <Center py="xl">
        <Loader />
      </Center>
    );
  }

  if (!me) {
    return (
      <Container size="xl">
        <Text c="dimmed">Could not load the partner dashboard.</Text>
      </Container>
    );
  }

  return (
    <Container size="xl">
      <Group justify="space-between" align="flex-start">
        <div>
          <Title order={1}>{me.displayName}</Title>
          <Text c="dimmed" mt={4}>
            {me.marketplaceName
              ? `Credits for ${me.marketplaceName} listings`
              : "Marketplace partner"}
          </Text>
        </div>
        <Button component={Link} to="/partner/codes/create" variant="default">
          Create signup code
        </Button>
      </Group>

      <SimpleGrid cols={{ base: 1, sm: 2 }} mt="lg">
        <Paper withBorder p="lg">
          <Text size="sm" c="dimmed">
            SKUs remaining in pool
          </Text>
          <Title order={2}>{me.skuPoolRemaining?.toLocaleString()}</Title>
        </Paper>
        <Paper withBorder p="lg">
          <Text size="sm" c="dimmed">
            Linked merchants
          </Text>
          <Title order={2}>{me.merchantCount}</Title>
        </Paper>
      </SimpleGrid>

      <Title order={3} mt="xl" mb="sm">
        Recent signups
      </Title>
      {me.recentRedemptions?.length ? (
        <Table striped>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Email</Table.Th>
              <Table.Th>Code</Table.Th>
              <Table.Th ta="right">SKUs</Table.Th>
              <Table.Th>When</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {me.recentRedemptions.map((r) => (
              <Table.Tr key={`${r.tenantId}-${r.at}`}>
                <Table.Td>{r.email}</Table.Td>
                <Table.Td>
                  <Code>{r.code}</Code>
                </Table.Td>
                <Table.Td ta="right">{r.skuGranted}</Table.Td>
                <Table.Td>
                  <Timeago date={r.at} />
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      ) : (
        <Text c="dimmed">No merchants have redeemed a code yet.</Text>
      )}

      <Stack mt="xl" gap="xs">
        <Button component={Link} to="/partner/merchants" variant="subtle">
          View all merchants
        </Button>
      </Stack>
    </Container>
  );
}
